import React from "react";
import "./footer.css";

export const Footer = () => {
  return (
    <>
      <footer class="footer">
        <div class="container">
          <div class="row">
            <div class="footer-col">
              <h4>MODA</h4>
              <ul>
                <li>
                  <a href="#">about us</a>
                </li>
                <li>
                  <a href="#">careers</a>
                </li>
                <li>
                  <a href="#">services</a>
                </li>
                <li>
                  <a href="#">community</a>
                </li>
                <li>
                  <a href="#">sustainability</a>
                </li>
                <li>
                  <a href="#">news</a>
                </li>
              </ul>
            </div>
            <div class="footer-col">
              <h4>get help</h4>
              <ul>
                <li>
                  <a href="#">FAQ</a>
                </li>
                <li>
                  <a href="#">shipping</a>
                </li>
                <li>
                  <a href="#">returns</a>
                </li>
                <li>
                  <a href="#">order status</a>
                </li>
                <li>
                  <a href="#">Store Locations</a>
                </li>
                <li>
                  <a href="#">exchanges & returns</a>
                </li>
              </ul>
            </div>
            <div class="footer-col">
              <h4>shop</h4>
              <ul>
                <li>
                  <a href="#">Living</a>
                </li>
                <li>
                  <a href="#">Bed</a>
                </li>
                <li>
                  <a href="#">Bath</a>
                </li>
                <li>
                  <a href="#">Dining</a>
                </li>
                <li>
                  <a href="#">Lighting</a>
                </li>
                <li>
                  <a href="#">Seating</a>
                </li>
              </ul>
            </div>
            <div class="footer-col">
              <h4>Yifei Xiao</h4>
              <ul>
                <li>
                  <a href="https://yifeixiaoo.github.io/">Website</a>
                </li>
                <li>
                  <a href="https://github.com/yifeixiaoo">Github</a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/yifeixiao/">LinkedIn</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
